import React from "react";
import { Skeleton } from "@progress/kendo-react-indicators";
import "./task-form.scss";

export default function TaskFormSkeleton() {
  return (
    <div className="task-form-skeleton form" data-testid="task-form-skeleton" style={{ background: "#f7fafd" }}>
      <div className="row m-0 h-100">
        <div className="d-flex flex-column w-100 form-row-child">
          <div className="form-back-panel">
            <Skeleton shape={'text'} style={{ width: 200 }} />
          </div>
          <div className="p-0 form-content">
            <div className="container-fluid p-0 h-100">
              <div className="row m-0 h-100 w-100">
                <div className="col-2 p-0 container-side-panel">
                  <div className="side-panel">
                    <div className="d-flex justify-content-between header">
                      <div className="header-ellipsis"> <Skeleton shape={'text'} style={{ width: 200 }} /></div>
                    </div>
                    <Skeleton shape={'text'} style={{ width: 200, marginBottom: 20 }} />
                    <Skeleton shape={'text'} style={{ width: 200, marginBottom: 20 }} />
                    <Skeleton shape={'text'} style={{ width: 200, marginBottom: 20 }} />
                    <Skeleton shape={'text'} style={{ width: 200, marginBottom: 20 }} />
                    <Skeleton shape={'text'} style={{ width: 200, marginBottom: 20 }} />
                    <Skeleton shape={'text'} style={{ width: 200, marginBottom: 20 }} />
                  </div>
                </div>
                <div className="col-10 p-0 container-form-fields">
                  <div className="form-fields">
                    <form className="d-flex flex-column h-100">
                      <div className="d-flex header justify-content-end">
                        <div className="header-middle-button">
                          <Skeleton shape="rectangle" style={{ width: 100, height: 20 }} />
                        </div>
                        <Skeleton shape="rectangle" style={{ width: 100, height: 20 }} />
                      </div>
                      <div className="overflow-auto form-fields-main">
                        <Skeleton shape={'text'} style={{ width: '20%' }} />
                        <Skeleton shape="rectangle" style={{ width: '100%', height: 20, marginBottom: 20 }} />
                        <Skeleton shape={'text'} style={{ width: '20%' }} />
                        <Skeleton shape="rectangle" style={{ width: '100%', height: 20, marginBottom: 20 }} />
                        <Skeleton shape={'text'} style={{ width: '20%' }} />
                        <Skeleton shape="rectangle" style={{ width: '100%', height: 20, marginBottom: 20 }} />
                        <Skeleton shape={'text'} style={{ width: '20%' }} />
                        <Skeleton shape="rectangle" style={{ width: '100%', height: 20, marginBottom: 20 }} />
                      </div>
                      <div className="d-flex justify-content-end footer">
                        <Skeleton shape={'text'} style={{ width: 300, marginRight: 20 }} />
                        <Skeleton shape="rectangle" style={{ width: 100, height: 20 }} />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}